// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `  .custom-file-upload>.img-wrap.img-wrap-hootsuite {
    position: relative;
    overflow: hidden;
    flex-direction: column;
    flex: 1 1;
    background-color: #F3F5F7;
    border-radius: 20px;
    width: 300px;
    height: 250px;
  }`, "",{"version":3,"sources":["webpack://./src/Assets/Css/Components/FieldHootsuiteUpload.css"],"names":[],"mappings":"EAAE;IACE,kBAAkB;IAClB,gBAAgB;IAChB,sBAAsB;IACtB,SAAO;IACP,yBAAyB;IACzB,mBAAmB;IACnB,YAAY;IACZ,aAAa;EACf","sourcesContent":["  .custom-file-upload>.img-wrap.img-wrap-hootsuite {\n    position: relative;\n    overflow: hidden;\n    flex-direction: column;\n    flex: 1;\n    background-color: #F3F5F7;\n    border-radius: 20px;\n    width: 300px;\n    height: 250px;\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
